import { z } from "zod";
import { dateSchema } from "./date";

export const econtractInfoSchema = z.object({
  createdAt: z.number().nullable().default(null),
  updatedAt: z.number().nullable().default(null),
  dealerXid: z.unknown().nullable().default(null),
  dealerName: z.string().nullable().default(null),
  signerXid: z.number().nullable().default(null),
  signerName: z.string().nullable().default(null),
  signerOrgTitle: z.string().nullable().default(null),
});

export const contractInfoSchema = z.object({
  dealerNote: z.string().nullable().default(null),
  rejectReason: z.string().nullable().default(null),
  rejectResolution: z.string().nullable().default(null),
  rejectNote: z.string().nullable().default(null),
  rejectResolutionDeadline: z.string().or(z.number()).nullable().default(null),
});

export const contractDetailsSchema = z.object({
  productId: z.string().nullable().default(null),
  productDiscountId: z.string().nullable().default(null),
  supplyProduct: z.string().nullable().default(null),
  contractSignPlace: z.string().nullable().default(null),
  contractSignDate: dateSchema,
  contractConclusionDate: dateSchema,
  contractStartDate: dateSchema,
  contractStartYear: z.number().nullable().default(null),
  contractEndDate: dateSchema,
  computedRenewalDate: dateSchema,
  salesChannel: z.string().nullable().default(null),
  digiChannel: z.string().nullable().default(null),
  sellChannel: z.string().nullable().default(null),
  sellChannelType: z.string().nullable().default(null),
  contractMethod: z.string().nullable().default(null),
  identificationFeActivation: z.boolean().default(false),
});
